const validationCalls : any = {

};
interface ValidationRule {
    name: string;
    required: boolean;
    type: string;
    min: number;
    max: number;
    checkForMember?: boolean;
}
interface FormRule {
    [key: string]: any;
}

const validations: FormRule = {
  required: {
    required: {
      value: true,
      message: 'This field is required.',
    },
  },
  bankaccount: {
    required: {
      value: true,
      message: 'This field is required.',
    },
    minLength: {
      value: 8,
      message: 'Is smaller than the minimum character limit: 8, please increase the number of characters provided.',
    },
    maxLength: {
      value: 8,
      message: 'Is greater than the maximum character limit: 8, please reduce the number of characters provided.',
    },
    pattern: {
      value: /^[0-9]*$/,
      message: 'Can only contain numbers.',
    },
  },
  banksort: {
    required: {
      value: true,
      message: 'This field is required.',
    },
    minLength: {
      value: 6,
      message: 'Is smaller than the minimum character limit: 6, please increase the number of characters provided.',
    },
    maxLength: {
      value: 6,
      message: 'Is greater than the maximum character limit: 6, please reduce the number of characters provided.',
    },
    pattern: {
      value: /^[0-9]*$/,
      message: 'Can only contain numbers.',
    },
  },
  ern: {
    validate: {
      validateAreaCode: (ernObject: any) => {
        let validationMessage = '';
        Object.keys(ernObject).forEach((ernKey: any) => {
          if (ernKey.indexOf('areacode') > -1) {
            const value = ernObject[ernKey];
            if (value) {
              if (value.length !== 3) validationMessage = 'Ern Area Code must be 3 characters long';
              if (value === '000') validationMessage = 'Ern Area Code can\'t be \'000\'';
            }
          }
        });
        return validationMessage.length === 0 || validationMessage;
      },
      validateSerialNumber: (ernObject: any) => {
        let validationMessage = '';
        Object.keys(ernObject).forEach((ernKey: any) => {
          if (ernKey.indexOf('serial_number') > -1) {
            const value = ernObject[ernKey];
            if (value) {
              if (value.length === 0) validationMessage = 'Ern Serial Number is required';
              if (value.length < 3) validationMessage = 'Ern Serial Number must be at least 3 characters long';
              if (value.length > 15) validationMessage = 'Ern Serial Number must no longer than 15 characters long';
              if (!/^[a-zA-Z]$/.test(value.substr(0, 1))) validationMessage = `Ern Serial Number First character '${value.substr(0, 1)}' can only be a letter`;
              if (!/^[a-zA-Z0-9]$/.test(value.substr(1, 1))) validationMessage = `Ern Serial Number Second character '${value.substr(1, 1)}' can only be a letter letter or a number`;
              if (!/^([0-9])*$/.test(value.substr(2, value.length - 1))) validationMessage = `Ern Serial Number characters '${value.substr(2, value.length - 1)}' can only contain numbers`;
              if (/^([0])*$/.test(value.substr(1, value.length - 1))) validationMessage = 'Ern Serial Number can\'t end with recurring zeros';
            }
          }
        });
        return validationMessage.length === 0 || validationMessage;
      },
    },
  },
  crn: {
    validate: {
      // all 8 alphanumeric characters long, may start with two letters
      lengthMatch: (crnString: string) => /^[a-zA-Z0-9]{8}$/.test(crnString) || 'Company Reg. Number must contain 8 alphanumeric characters (older companies may need leading zeroes).',
      typeMatch: (crnString: string) => /[0-9]{6,8}$/.test(crnString) || 'Company Reg. Number must end with at least 6 numeric characters.',
    },
  },
  radio: {

  },
  select: {
    required: {
      value: true,
      message: 'Please choose any option from the drop down list above.',
    },
    validate: {
      notEmpty: (value: string) => value !== 'false' || 'Please choose any option from the drop down list above.',
    },
  },
  name: {
    minLength: {
      value: 2,
      message: 'Is smaller than the minimum character limit: 2, please increase the number of characters provided.',
    },
    maxLength: {
      value: 100,
      message: 'Is greater than the maximum character limit: 100, please reduce the number of characters provided.',
    },
    pattern: {
      value: /^[a-zA-Z' -]*$/,
      message: 'Contains invalid characters, please ensure only letters, spaces and apostrophes are provided.',
    },
  },
  member: {
    validate: {
      checkEmail: async (value: string) => {
        if (!Object.prototype.hasOwnProperty.call(validationCalls, 'email')) {
          validationCalls.email = fetch(`/KPS_TOOLS/ajax_calls.inc?${new URLSearchParams({
            action: 'member_check_available',
            eml: escape(value),
            result: 'true',
            ptc: window.kbSchema.transaction.ptc,
          })}`, {
            method: 'POST',
          })
            .then((emailResponse) => emailResponse.json());
        }
        const response = await validationCalls.email;
        delete validationCalls.email;
        return response.exists === 'false' || 'Email already exists, you may wish to <a class="purple-link" href="/login.html" target="_blank">log in</a> to renew your policy or update your details.';
      },
    },
  },
  email: {
    pattern: {
      value: /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2}|abogado|ac|academy|accountants|active|actor|ad|ae|aero|af|ag|agency|ai|airforce|al|allfinanz|alsace|am|an|android|ao|aq|ar|archi|army|arpa|as|asia|associates|at|attorney|au|auction|audio|autos|aw|ax|axa|az|ba|band|bar|bargains|bayern|bb|bd|be|beer|berlin|best|bf|bg|bh|bi|bid|bike|bio|biz|bj|black|blackfriday|bloomberg|blue|bm|bmw|bn|bnpparibas|bo|boo|boutique|br|brussels|bs|bt|budapest|build|builders|business|buzz|bv|bw|by|bz|bzh|ca|cab|cal|camera|camp|cancerresearch|capetown|capital|caravan|cards|care|career|careers|casa|cash|cat|catering|cc|cd|center|ceo|cern|cf|cg|ch|channel|cheap|christmas|chrome|church|ci|citic|city|ck|cl|claims|cleaning|click|clinic|clothing|club|cm|cn|co|coach|codes|coffee|college|cologne|com|community|company|computer|condos|construction|consulting|contractors|cooking|cool|coop|country|cr|credit|creditcard|cricket|crs|cruises|cu|cuisinella|cv|cw|cx|cy|cymru|cz|dad|dance|dating|day|de|deals|degree|delivery|democrat|dental|dentist|desi|dev|diamonds|diet|digital|direct|directory|discount|design|dj|dk|dm|dnp|do|domains|durban|dvag|dz|earth|eat|ec|edu|education|ee|eg|email|emerck|energy|engineer|engineering|enterprises|equipment|er|es|esq|estate|et|eu|eus|events|everbank|exchange|expert|exposed|fail|farm|feedback|fi|film|finance|financial|firmdale|fish|fishing|fitness|fj|fk|flights|florist|flsmidth|fly|fm|fo|foo|forsale|foundation|fr|frl|frogans|fund|furniture|futbol|ga|gal|gallery|gb|gbiz|gd|ge|gent|gf|gg|gh|gi|gift|gifts|gives|gl|glass|gle|global|globo|gm|gmail|gmo|gmx|gn|google|gop|gov|gp|gq|gr|graphics|gratis|green|gripe|group|gs|gt|gu|guide|guitars|guru|gw|gy|hamburg|haus|healthcare|help|here|hiphop|hiv|hk|hm|hn|holdings|holiday|homes|horse|host|hosting|house|how|hr|ht|hu|ibm|id|ie|il|im|immo|immobilien|in|industries|info|ing|ink|institute|insure|int|international|investments|io|iq|ir|is|it|je|jetzt|jm|jo|jobs|joburg|jp|juegos|kaufen|ke|kg|kh|ki|kim|kitchen|kiwi|km|kn|koeln|kp|kr|krd|kred|kw|ky|kz|la|lacaixa|land|law|lawyer|lb|lc|lds|lease|legal|lgbt|li|life|lighting|limited|limo|link|live|lk|loans|london|lotto|lr|ls|lt|ltd|ltda|lu|luxe|luxury|lv|ly|ma|madrid|maison|management|mango|market|marketing|mc|md|me|media|meet|melbourne|meme|memorial|menu|mg|mh|miami|mil|mini|mk|ml|mm|mn|mo|mobi|moda|moe|monash|money|mormon|mortgage|moscow|motorcycles|mov|mp|mq|mr|ms|mt|mu|museum|mv|mw|mx|my|mz|na|nagoya|name|navy|nc|ne|net|network|neustar|new|nexus|nf|ng|ngo|nhk|ni|ninja|nl|no|np|nr|nra|nrw|nu|nyc|nz|okinawa|om|ong|onl|online|ooo|org|organic|otsuka|ovh|pa|paris|partners|parts|party|pe|pf|pg|ph|pharmacy|photo|photography|photos|physio|pics|pictures|pink|pizza|pk|pl|place|plumbing|pm|pn|pohl|poker|post|pr|praxi|press|pro|prod|productions|prof|properties|property|ps|pt|pub|pw|py|qa|qpon|quebec|re|realtor|recipes|red|rehab|reise|reisen|reit|ren|rentals|repair|report|republican|rest|restaurant|reviews|rich|rio|rip|ro|rocks|rodeo|rs|rsvp|ru|ruhr|rw|ryukyu|sa|saarland|sarl|sb|sc|sca|scb|schmidt|schule|science|scot|sd|se|services|sg|sh|shiksha|shoes|si|singles|sj|sk|sl|sm|sn|so|social|software|sohu|solar|solutions|soy|space|spiegel|sr|st|site|studio|su|supplies|supply|support|surf|surgery|suzuki|sv|sx|sy|sydney|systems|sz|taipei|tatar|tattoo|tax|tc|td|tdl|tech|technology|tel|tf|tg|th|tienda|tips|tirol|tj|tk|tl|tld|tm|tn|to|today|tokyo|tools|top|town|toys|tp|tr|trade|training|travel|tt|tui|tv|tw|tz|ua|ug|uk|university|uno|uol|us|uy|uz|va|vacations|vc|ve|vegas|ventures|versicherung|vet|vg|vi|viajes|villas|vision|vlaanderen|vn|vodka|vote|voting|voto|voyage|vu|wales|wang|watch|webcam|website|wed|wedding|wf|whoswho|wien|wiki|williamhill|wme|work|works|world|ws|wtc|wtf|xxx|xyz|yachts|yandex|ye|yoga|yokohama|youtube|yt|za|zip|zm|zone|zw)\b$/,
      message: 'Please enter a valid email.',
    },
  },
  age: {
    validate: {
      validDate: (date: string) => /^[0-3][0-9]\/[0-1][0-9]\/[12][90][0-9][0-9]$/.test(date) || 'Is not a valid date, please ensure that the given date follows the following format dd/mm/yyyy',
      olderThan18: (date: string) => {
        const dateParts: any = date.split('/');
        const selectedDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        const now = new Date();
        let age = now.getFullYear() - selectedDate.getFullYear();
        const m = now.getMonth() - selectedDate.getMonth();
        if (m < 0 || (m === 0 && now.getDate() < selectedDate.getDate())) {
          age -= 1;
        }
        return age > 18 || 'You must be older than 18 years for this product.';
      },
      youngerThan80: (date: string) => {
        const dateParts: any = date.split('/');
        const selectedDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        const now = new Date();
        let age = now.getFullYear() - selectedDate.getFullYear();
        const m = now.getMonth() - selectedDate.getMonth();
        if (m < 0 || (m === 0 && now.getDate() < selectedDate.getDate())) {
          age -= 1;
        }
        return age < 80 || 'You must be younger than 80 years for this product.';
      },
    },
  },
  inception: {
    validate: {
      notInThePast: (date: string) => {
        const selectedDate = new Date(date);
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        return selectedDate >= now || 'You can only purchase a new policy with a inception date for today or 45 days within the future, inception date given is in the past.';
      },
      inside45Days: (date: string) => {
        const selectedDate = new Date(date);
        const now = new Date();
        now.setDate(now.getDate() + 46);
        now.setHours(0, 0, 0, 0);
        return selectedDate < now || 'You can only purchase a new policy with a inception date for today or 45 days within the future, inception date given is greater than 45 days from today.';
      },
    },
  },
  phone: {
    minLength: {
      value: 10,
      message: 'Needs to be greater than 10 numbers long.',
    },
    maxLength: {
      value: 13,
      message: 'Needs to be shorter than 13 numbers long.',
    },
    validate: {
      startNumber: (number: string) => {
        if (!number || number.length === 0) return true;
        return /^[0-9+]*$/.test(number.charAt(0)) || 'Can only contain numbers, please remove unwanted characters or symbols.';
      },
      secondNumber: (number: string) => {
        if (!number || number.length === 0) return true;
        return /^[0-9+]*$/.test(number.slice(1)) || 'Can only contain numbers, please remove unwanted characters or symbols.';
      },
      startsWithZero: (number: string) => {
        if (!number || number.length === 0) return true;
        return (number.charAt(0) === '0' || number.charAt(0) === '+') || 'Valid UK phone numbers start with the number zero, please ensure you provide such a number.';
      },
      noRepeatingNumbers: ((number: string) => {
        if (!number || number.length === 0) return true;
        // check its not all one value (01111111111111)
        let charstr = '';
        const val = number.substring(1); // Remove the zero from the string
        const chars = val.split('');

        // eslint-disable-next-line no-restricted-syntax
        for (const char in chars) {
          if (charstr.indexOf(chars[char]) === -1) { charstr += chars[char]; }
        }

        return charstr.length >= 2 || 'Cannot be a repeating number, please enter a valid phone number.';
      }),
    },
  },
};

const getValidation = (data: any): FormRule => {
  // Check if validation has required
  let validationRules: FormRule = data.required ? validations.required : {};

  if (data.rules && data.rules.length) {
    data.rules.forEach((rule: ValidationRule) => {
      if (Object.prototype.hasOwnProperty.call(validations, rule.type)) {
        if (validationRules.validate) {
          validationRules.validate = {
            ...validationRules.validate,
            ...validations[rule.type].validate,
          };
        } else {
          validationRules = {
            ...validationRules,
            ...validations[rule.type],
          };
        }
      }
      if (rule.checkForMember) {
        validationRules = {
          ...validationRules,
          ...validations.member,
        };
      }
      if (rule.required) {
        validationRules = {
          ...validationRules,
          ...validations.required,
        };
      }
    });
  }
  return validationRules;
};
// export default validations;
export default getValidation;
